import { AttachmentImage } from "src/app/_models/image.model";
import { Building } from "../building.model";

export class Floor {
  id: number;
  name: string;
  description: string;
  idBuilding: number;
  level: number;
  building: Building;
  // Below optional property if floor list is in form and has to be checked
  checked?: boolean;
  floorPlan?: AttachmentImage = new AttachmentImage();
}
